/** @jsx jsx */
import { jsx, Flex, Styled } from "theme-ui"
import PropTypes from "prop-types"

import { Large } from "components/type"

import useLocales from "hooks/use-locales"

const Infographic = ({ Icon, current, previous, children, iconWidth }) => {
  const { t } = useLocales()
  return (
    <Flex sx={{ my: 4, flexDirection: "column", alignItems: "flex-start" }}>
      <Icon sx={{ width: iconWidth, height: "auto" }} />
      <Styled.h3 as="p">
        <span sx={{ mb: 0, mt: 1, color: "primary" }}>{current}</span>
        <Large sx={{ my: 0 }}>{children}</Large>
        <span sx={{ mb: 0, mt: 1, fontSize: 3, color: "text" }}>
          {previous} {t("previous")}
        </span>
      </Styled.h3>
    </Flex>
  )
}

Infographic.defaultProps = {
  iconWidth: ["100%", "64px"],
}

Infographic.propTypes = {
  Icon: PropTypes.any.isRequired,
  current: PropTypes.string.isRequired,
  previous: PropTypes.string.isRequired,
  children: PropTypes.any,
  iconWidth: PropTypes.oneOf([
    PropTypes.number,
    PropTypes.array,
    PropTypes.string,
  ]),
}

export default Infographic
